import CartTotal from "components/Cart/CartTotal"
import ProductTable from "components/Product/ProductTableReadOnly"
import Spinner from "components/Spinner/Spinner"
import _ from "lodash"
import {observer} from "mobx-react"
import moment from "moment"
import React, {Component, useEffect} from "react"
import {withRouter} from "react-router"
import {Link} from "react-router-dom"
import {Button, Container, Grid, Icon, Image, Segment, Step} from "semantic-ui-react"
import shop from "shop/shop"
import "style/CheckoutPage.scss"

import paypalLogo from "assets/de-pp-logo-200px.png"

export default class CheckoutPaymentPage extends Component {

	state = {
		loading: false,
		bill   : false,
		byId   : {}
	}

	componentDidMount() {

	}

	submit = () => {

		// setup manually
		const extras = {
			delivery_address_id : shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.mapid,
			manual_order_id     : shop.cart.getExtra( "manual_order_id" ),
			is_quotation_request: shop.cart.getExtra( "is_quotation_request" ),
			attachments         : shop.cart.getExtra( "attachments" ),
			"ts-ordertype"      : shop.cart.getExtra( "is_quotation_request" ) ? "offer" : null,
			"print_receipt"     : shop.cart.getExtra( "print_receipt" ),
		}

		// merge all data
		_.map( shop.cart.data.extras, ( value, key ) => {
			if ( !extras[key] ) extras[key] = value
		} )
	}

	render() {
		const {bill, byId, loading} = this.state

		if ( loading ) {
			return <div className="pa4 tc">
				<Spinner size="md" type="inverted" /></div>
		}

		return <Page
			billingAddress={shop.session.value}
			deliveryAddress={shop.session.value}
			bill={bill} byId={byId} />
	}
}


const CheckoutSteps = () => (
	<Step.Group fluid size={"small"}>
		<Step completed as={Link} to={`/checkout/`}>
			<Icon name={"shopping cart"} />
			<Step.Content size="small">
				<Step.Title>Warenkorb</Step.Title>
				<Step.Description>Produkte</Step.Description>
			</Step.Content>
		</Step>

		<Step completed as={Link} to={`/checkout/delivery/`}>
			<Icon name={"truck"} />
			<Step.Content size="small">
				<Step.Title>Versand</Step.Title>
				<Step.Description>Liefer- und Rechnungsadresse</Step.Description>
			</Step.Content>
		</Step>

		<Step active>
			<Icon name="payment" />
			<Step.Content>
				<Step.Title>Bezahlung</Step.Title>
				<Step.Description>Bezahlung mit Paypal</Step.Description>
			</Step.Content>
		</Step>

		<Step>
			<Step.Content>
				<Icon name="flag checkered" />
			</Step.Content>
		</Step>
	</Step.Group>
)


const Page = observer( ( {deliveryAddress, billingAddress, byId} ) => {
	const {products} = shop.cart
	return (
		<div className="">

			<Container>
				<div className="pa3">
					<CheckoutSteps />
				</div>
			</Container>

			<div className={""}>
				<Container className="billing pt3">
					<section className="billing-tab">

						{/*<div className="checkout-logo mb3"><img className="" src={shop.config.logo}/></div>*/}
						<h1 className="tl ttu b pb2">Checkout</h1>

					</section>

					<section className="pt4">
						<Grid stackable>
							<Grid.Row>
								<Grid.Column computer={9}>
									<section className="billing-tab pb4">

										<div className="pb3">
											<h3 className="">{translate( "Bezahlung mit" )}</h3>
											<Image src={paypalLogo} />
											<hr />
										</div>


										<div className="flex flex-row">
											{/*  RECHNUNGSADRESSE */}
											<div className="w-100 mr3">
												<h3>{translate("Rechnungsadresse")}</h3>
												<p>
													{billingAddress.title}
													{billingAddress.name1} {billingAddress.name2} {billingAddress.name3} <br />
													{billingAddress.street} <br />
													{billingAddress.pcode} {billingAddress.city} <br />
													{billingAddress.country}
												</p>
											</div>

											{/*  LIEFERANSCHRIFT */}
											<div className="w-100 ">
												<h3>{translate( "Lieferadresse" )}</h3>
												{deliveryAddress.name ? <p>
													{deliveryAddress.title} {deliveryAddress.name1} {deliveryAddress.name2} {deliveryAddress.name3} <br />
													{deliveryAddress.street} <br />
													{deliveryAddress.pcode} {deliveryAddress.city} <br />
													{deliveryAddress.country}
												</p> : <p>
													{billingAddress.title} {billingAddress.name1} {billingAddress.name2} {billingAddress.name3} <br />
													{billingAddress.street} <br />
													{billingAddress.pcode} {billingAddress.city} <br />
													{billingAddress.country}
												</p>}
											</div>
										</div>


									</section>

									<h3><span>{translate( "Ihre Bestellung" )}</span></h3>
									<ProductTable minimal cart={shop.cart} products={products} showTax />


								</Grid.Column>
								<Grid.Column
									computer={7}
								>
									<h3 className="">{translate( "Zusammenfassung" )}</h3>
									<div className="pa4 bg-silver">
										<div className="  ">
											<CartTotal fluid showTax className={"w-100"} />
										</div>
									</div>

									<div className="pt3">
										<h3 className="">{translate( "Bezahlung" )}</h3>
										<div className="pa4 bg-silver">
											{shop.cart.ready && <Paypal
												deliveryAddress={deliveryAddress}
												billingAddress={billingAddress}
												key={shop.cart.sum} />}
										</div>
									</div>
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</section>

					{/*<section className="billing-tab pt4">*/}
					{/*  <h2>{isOffer ? <span>{translate( "Ihre Anfrage" )}</span> : <span>{translate( "Ihre Bestellung" )}</span>}</h2>*/}
					{/*  <SuccessTable positions={order.positions} byId={byId} netto={order.netto} currency={order.currency}/>*/}

					{/*  {order.customer.extras.zahlung && <div>*/}
					{/*    <h3 className="mt4">{translate( "Zahlungsweise" )}</h3>*/}
					{/*    <p>{order.customer.extras.zahlung}</p>*/}
					{/*  </div>}*/}

					{/*  <h3 className="mt4">{translate( "your comment" )}</h3>*/}
					{/*  <p>{order.comment}</p>*/}

					{/*  {order.deliverdate && <div>*/}
					{/*    <h3 className="mt4">{translate( "Liefertermin (Wunsch)" )}</h3>*/}
					{/*    <p>{moment( moment( order.deliverdate ), "DD.MM.YYYY" ).format( "dddd, DD. MMMM YYYY" )}</p>*/}
					{/*  </div>}*/}

					{/*  {order.extras.attachments && <div>*/}
					{/*    <h3 className="mt4">Ihr Anhang</h3>*/}
					{/*    <p>{order.extras.attachments}</p>*/}
					{/*  </div>}*/}

					{/*  {order.extras.print_receipt && <div>*/}
					{/*    <h3 className="mt4">{translate( "Belegausdruck/Innendienst" )}</h3>*/}
					{/*    <p>{order.extras.print_receipt}</p>*/}
					{/*  </div>}*/}

					{/*  /!*<div className="mt4">*!/*/}
					{/*  /!*  <p className="b"><i className="icon-info-circled"/> {translate( "confirmation.notice" )}</p>*!/*/}
					{/*  /!*  <p>{translate( "confirmation.notice2" )}</p>*!/*/}
					{/*  /!*</div>*!/*/}
					{/*</section>*/}

					{shop.config.checkout_thank_you && <div className="pv4">
						<div style={{whiteSpace: "pre-line"}}>{window.translate( "checkout_thank_you" )}</div>
					</div>}


					<section className="text-left pt3 tc">
						<Link to="/"> <Button type="primary"> <Icon name="chevron left" />{translate( "zurück zum Shop" )}</Button> </Link>
					</section>

					<br />
				</Container>
			</div>
		</div>
	)
} )


const getProducts = () => shop.cart.map( ( product ) => product )


@withRouter
@observer
class Paypal extends React.Component {

	state = {
		payment: false,
	}

	componentDidMount() {
		const {history, deliveryAddress, billingAddress} = this.props
		// TODO FIX CART SUM WITH THOMAS - DECIMALS

		const items = shop.cart.products.map( p => {
				return {
					name       : p.title.split( "/" ).join( " " ),
					sku        : p.article_nr,
					unit_amount: {value: p.price.toFixed( 2 ), currency_code: 'EUR'},
					debug_sum  : `${(p.price.toFixed( 2 ) * p.count * p.unit_multi).toFixed( 2 )}`,
					// tax        : { value: `${Number( p.price / 100 * 19 ).toFixed( 2 )}`, currency_code: 'EUR' },
					quantity   : `${p.count * p.unit_multi}`,
					currency   : "EUR",
				}
			}
		)

		const brutto = shop.cart.products.reduce( ( a, b ) => a + (1.19 * b.count * b.unit_multi * b.price.toFixed( 2 )), 0 )
		const sum = shop.cart.products.reduce( ( a, b ) => a + (b.count * b.unit_multi * b.price.toFixed( 2 )), 0 )
		const tax = (sum / 100 * 19).toFixed( 2 )

		window.localStorage.foo = "bar"

		const renderButtons = () => {
			const {paypal} = window
			if (!paypal) {
				console.error( "PayPal SDK konnte nicht geladen werden" )
				return
			}
			// Render the PayPal button into #paypal-button-container
			paypal.Buttons( {
				// Set up the transaction
				createOrder: ( data, actions ) => {
					return actions.order.create( {
						purchase_units: [{
							"reference_id"  : `bshop_order_${moment().format( "YYYY-MM-DD HH:mm" )}-${shop.session.value.map_id}`,
							"description"   : `Bestellung ${moment().format( "YYYY-MM-DD HH:mm" )} von Kunde ${shop.session.value.map_id}`,
							"amount"        : {
								"currency_code": "EUR",
								"value"        : `${(brutto).toFixed( 2 )}`,
								"breakdown"    : {
									"item_total": {currency_code: "EUR", value: `${sum.toFixed( 2 )}`},
									"tax_total" : {currency_code: "EUR", value: `${tax}`}
								},
							},
							billing_address : {
								line1       : `${billingAddress.street}`,
								line2       : `${billingAddress.addition}`,
								city        : `${billingAddress.city}`,
								postal_code : `${billingAddress.pcode} `,
								country_code: billingAddress.country
							},
							shipping_address: {
								line1       : `TEST STREET ${deliveryAddress.street} 3`,
								line2       : `${deliveryAddress.addition}`,
								city        : `${deliveryAddress.city}`,
								postal_code : `${deliveryAddress.pcode} `,
								country_code: deliveryAddress.country
							},
							// "payee"       : {
							//   "email": "seller@example.com"
							// },
							items,

						}]
					} );
				},

				// Finalize the transaction
				onApprove: ( data, actions ) => {
					return actions.order.capture().then( ( payment ) => {
						console.log( "PAYMENT AUTH RECEIVED", {payment} )
						// Show a success message to the buyer
						shop.cart.setExtra( "payment", JSON.stringify( payment ) )
						history.replace( "/checkout/success/" )
						console.log( {payment} )
						this.setState( {payment} )
					} )
				}
			} ).render( "#paypal-button-container" );
		}

		if ( window.paypal ) {
			renderButtons()
		} else {
			// PayPal SDK-Script fehlt auf dieser Seite (z.B. wenn sie über das SEO-Modul
			// ohne den Script-Tag in _document.js ausgeliefert wird) - dynamisch nachladen.
			if ( !process.env.REACT_APP_PAYPAL_CLIENT_ID ) {
				console.error( "REACT_APP_PAYPAL_CLIENT_ID ist nicht konfiguriert - PayPal SDK kann nicht geladen werden" )
				return
			}
			const scriptId = "paypal-sdk"
			const existingScript = document.getElementById( scriptId )
			if ( existingScript ) {
				existingScript.addEventListener( "load", renderButtons )
			} else {
				const script = document.createElement( "script" )
				script.id = scriptId
				script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&currency=EUR`
				script.onload = renderButtons
				script.onerror = () => console.error( "PayPal SDK konnte nicht geladen werden" )
				document.head.appendChild( script )
			}
		}
	}

	render() {
		const items = shop.cart.products.map( p => {
				return {
					name       : p.title.split( "/" ).join( " " ),
					sku        : p.article_nr,
					unit_amount: {value: p.price.toFixed( 2 ), currency_code: 'EUR'},
					debug_sum  : `${(p.price.toFixed( 2 ) * p.count * p.unit_multi).toFixed( 2 )}`,
					// tax        : { value: `${Number( p.price / 100 * 19 ).toFixed( 2 )}`, currency_code: 'EUR' },
					quantity   : `${p.count * p.unit_multi}`,
					currency   : "EUR",
				}
			}
		)

		const brutto = shop.cart.products.reduce( ( a, b ) => a + (1.19 * b.count * b.unit_multi * b.price.toFixed( 2 )), 0 )
		const sum = shop.cart.products.reduce( ( a, b ) => a + (b.count * b.unit_multi * b.price.toFixed( 2 )), 0 )
		const tax = (sum / 100 * 19).toFixed( 2 )
		const {payment} = this.state
		return <div>
			<div>

				{/*<pre>{JSON.stringify( {brutto, sum, tax, items}, null, 2 )}</pre>*/}

				{payment && <Segment inverse>
				</Segment>
				}
				<div className="tc">
					<div id="paypal-button-container"></div>
				</div>
			</div>
		</div>
	}
}


// EXAMPLE PURCHASE UNITS
//"purchase_units": [
//     {
//       "reference_id": "store_mobile_world_order_1234",
//       "description": "Mobile World Store order-1234",
//       "amount": {
//         "currency": "USD",
//         "details": {
//           "subtotal": "1.09",
//           "shipping": "0.02",
//           "tax": "0.33"
//         },
//         "total": "1.44"
//       },
//       "payee": {
//         "email": "seller@example.com"
//       },
//       "items": [
//         {
//           "name": "NeoPhone",
//           "sku": "sku03",
//           "price": "0.54",
//           "currency": "USD",
//           "quantity": "1"
//         },
//         {
//           "name": "Fitness Watch",
//           "sku": "sku04",
//           "price": "0.55",
//           "currency": "USD",
//           "quantity": "1"
//         }
//       ],
//       "shipping_address": {
//         "line1": "2211 N First Street",
//         "line2": "Building 17",
//         "city": "San Jose",
//         "country_code": "US",
//         "postal_code": "95131",
//         "state": "CA",
//         "phone": "(123) 456-7890"
//       },
//       "shipping_method": "United Postal Service",
//       "partner_fee_details": {
//         "receiver": {
//           "email": "partner@example.com"
//         },
//         "amount": {
//           "value": "0.01",
//           "currency": "USD"
//         }
//       },
//       "payment_linked_group": 1,
//       "custom": "custom_value_2388",
//       "invoice_number": "invoice_number_2388",
//       "payment_descriptor": "Payment Mobile World"
//     }
//   ],

const defaultBill = {
	"netto"     : "2285.26",
	"created"   : "2020-02-18 14:01:13",
	"handid"    : "",
	"bill"      : {
		"country": "DE",
		"referer": null,
		"pcode"  : "50735",
		"city"   : "Köln",
		"type"   : 0,
		"name3"  : null,
		"phone"  : "",
		"street" : null,
		"mapid"  : "",
		"name2"  : "",
		"fax"    : "",
		"name1"  : "Barverkauf Bonkasse Köln",
		"email"  : "",
		"hash"   : null
	},
	"extras"    : {"ts-ordertype": "null", "is_quotation_request": "false", "delivery_address_id": "false", "sumDiscount": "null"},
	"positions" : [{
		"created"   : "2020-02-18 13:21:28",
		"unit_multi": 1,
		"count"     : 14,
		"vat"       : 19,
		"extras"    : {
			"discount_value_sum" : "null",
			"custom_discount_sum": "null",
			"custom_price"       : "null",
			"custom_savings"     : "null",
			"custom_price_sum"   : "null",
			"custom_savings_sum" : "null"
		},
		"sum"       : 941.052,
		"pid"       : "68229aa5-7755-4ce7-9401-83d3b37fba25",
		"article_id": "A860-06",
		"pos"       : 1,
		"price"     : 67.218,
		"article_nr": "A860-06",
		"currency"  : "EUR",
		"unit_id"   : "Stck",
		"barcode"   : "8691607860061",
		"unit_desc" : "Stck",
		"open"      : 0,
		"desc"      : "Kahvekolik Coffee Maker - RosaGold/Krom / A860-06",
		"customer"  : "11111"
	}, {
		"created"   : "2020-02-18 13:21:36",
		"unit_multi": 1,
		"count"     : 5,
		"vat"       : 19,
		"extras"    : {
			"discount_value_sum" : "null",
			"custom_discount_sum": "null",
			"custom_price"       : "null",
			"custom_savings"     : "null",
			"custom_price_sum"   : "null",
			"custom_savings_sum" : "null"
		},
		"sum"       : 336.09000000000003,
		"pid"       : "45f5cb47-8c1f-45d8-8e60-a3cf20938aad",
		"article_id": "A860-04",
		"pos"       : 2,
		"price"     : 67.218,
		"article_nr": "A860-04",
		"currency"  : "EUR",
		"unit_id"   : "Stck",
		"barcode"   : "8691607860047",
		"unit_desc" : "Stck",
		"open"      : 0,
		"desc"      : "Kahvekolik Coffee Maker - Turquoise / A860-04",
		"customer"  : "11111"
	}, {
		"created"   : "2020-02-18 13:21:38",
		"unit_multi": 1,
		"count"     : 8,
		"vat"       : 19,
		"extras"    : {
			"discount_value_sum" : "null",
			"custom_discount_sum": "null",
			"custom_price"       : "null",
			"custom_savings"     : "null",
			"custom_price_sum"   : "null",
			"custom_savings_sum" : "null"
		},
		"sum"       : 537.744,
		"pid"       : "fca478de-0891-442a-bfa7-0809d36d0475",
		"article_id": "A860-03",
		"pos"       : 3,
		"price"     : 67.218,
		"article_nr": "A860-03",
		"currency"  : "EUR",
		"unit_id"   : "Stck",
		"barcode"   : "8691607860030",
		"unit_desc" : "Stck",
		"open"      : 0,
		"desc"      : "Kahvekolik Coffee Maker - Rot / A860-03",
		"customer"  : "11111"
	}, {
		"created"   : "2020-02-18 13:21:41",
		"unit_multi": 1,
		"count"     : 1,
		"vat"       : 19,
		"extras"    : {
			"discount_value_sum" : "null",
			"custom_discount_sum": "null",
			"custom_price"       : "null",
			"custom_savings"     : "null",
			"custom_price_sum"   : "null",
			"custom_savings_sum" : "null"
		},
		"sum"       : 67.218,
		"pid"       : "cafe8ff8-1b56-4b92-8489-2efc2bb12a7b",
		"article_id": "A860-07",
		"pos"       : 4,
		"price"     : 67.218,
		"article_nr": "A860-07",
		"currency"  : "EUR",
		"unit_id"   : "Stck",
		"barcode"   : "",
		"unit_desc" : "Stck",
		"open"      : 0,
		"desc"      : "Kahvekolik Coffee Maker - Black / Krom / A860-07",
		"customer"  : "11111"
	}, {
		"created"   : "2020-02-18 13:21:40",
		"unit_multi": 1,
		"count"     : 4,
		"vat"       : 19,
		"extras"    : {
			"discount_value_sum" : "null",
			"custom_discount_sum": "null",
			"custom_price"       : "null",
			"custom_savings"     : "null",
			"custom_price_sum"   : "null",
			"custom_savings_sum" : "null"
		},
		"sum"       : 268.872,
		"pid"       : "22c9c590-219b-4f58-a830-0962f3b6c56a",
		"article_id": "A860",
		"pos"       : 5,
		"price"     : 67.218,
		"article_nr": "A860",
		"currency"  : "EUR",
		"unit_id"   : "Stck",
		"barcode"   : "8691607008609",
		"unit_desc" : "Stck",
		"open"      : 0,
		"desc"      : "Kahvekolik Coffee Maker - Pink / A860",
		"customer"  : "11111"
	}, {
		"created"   : "2020-02-18 13:21:41",
		"unit_multi": 1,
		"count"     : 2,
		"vat"       : 19,
		"extras"    : {
			"discount_value_sum" : "null",
			"custom_discount_sum": "null",
			"custom_price"       : "null",
			"custom_savings"     : "null",
			"custom_price_sum"   : "null",
			"custom_savings_sum" : "null"
		},
		"sum"       : 134.286,
		"pid"       : "060ef923-bebe-4e09-af8b-b799c34e6971",
		"article_id": "A860-02",
		"pos"       : 6,
		"price"     : 67.143,
		"article_nr": "A860-02",
		"currency"  : "EUR",
		"unit_id"   : "Stck",
		"barcode"   : "8691607860023",
		"unit_desc" : "Stck",
		"open"      : 0,
		"desc"      : "Kahvekolik Coffee Maker Black Gold A860-02",
		"customer"  : "11111"
	}],
	"source"    : 0,
	"map_id"    : "",
	"contact"   : {
		"country": null,
		"referer": null,
		"pcode"  : null,
		"city"   : null,
		"type"   : 0,
		"name3"  : null,
		"phone"  : null,
		"street" : null,
		"mapid"  : "",
		"name2"  : null,
		"fax"    : null,
		"name1"  : null,
		"email"  : null,
		"hash"   : null
	},
	"customerid": "11111",
	"comment"   : "TESTBESTELLUNG ",
	"id"        : 82,
	"hash"      : null,
	"register"  : "2020-02-18 14:01:13",
	"status"    : 0,
	"customer"  : {
		"country"       : "DE",
		"city"          : "Köln",
		"pcode"         : "50735",
		"handid"        : "",
		"extras"        : {},
		"title"         : "Barverkauf Bonkasse Köln",
		"map_deliver_id": "11111",
		"imcontact"     : "",
		"map_id"        : "11111",
		"web"           : "",
		"street"        : null,
		"map_bill_id"   : "11111",
		"currency"      : "EUR",
		"lang"          : "de",
		"fax"           : "",
		"locked"        : false,
		"email"         : "",
		"tgcontact"     : "",
		"addition"      : "",
		"mobile"        : "",
		"pricelist"     : "3",
		"warn"          : "",
		"phone"         : "",
		"subtitle"      : "",
		"hash"          : "c42a68e0c42d37287fd25f90d64bacbb"
	},
	"deliver"   : {}
}


// WEBPACK FOOTER //
// ./src/pages/checkout/CheckoutPaymentPage.js